import React from 'react';
import { BoxProps } from '@mui/material';
import CellContainer from 'shared/lib/extendedComponents/grids/components/cellContainer';
import IconDownload from 'shared/icons/iconDownload';

export default function MobileItemDownload({
  onDownload,
  ...other
}: {
  onDownload?: () => void;
} & BoxProps) {
  return (
    <CellContainer
      {...other}
      sx={{
        cursor: 'pointer',
        flexShrink: 0,
        ...other.sx,
      }}
    >
      <IconDownload
        sizeKey="32x32"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onDownload && onDownload();
        }}
      ></IconDownload>
    </CellContainer>
  );
}
